// fetch get はbodyを使えないので、共通化のときに考慮する。
// Failed to execute 'fetch' on 'Window': Request with GET/HEAD method cannot have body.

export const get = (url, callback) => {
  fetch(url, { credentials: 'include' })
    .then((response) => response.json())
    .then((data) => callback(data))
    .catch((error) => console.error('GET ' + url + error))
}

export const put = (url, body, callback) => {
  fetch(url, {
    method: 'PUT',
    body: JSON.stringify(body),
    headers: new Headers({ 'Content-type': 'application/json' }),
    credentials: 'include',
  })
    .then((response) => response.json())
    .then((data) => callback(data))
    .catch((error) => console.error('PUT ' + url + error))
}

export const post = (url, body, callback) => {
  fetch(url, {
    method: 'POST',
    body: JSON.stringify(body),
    headers: new Headers({ 'Content-type': 'application/json' }),
    credentials: 'include',
  })
    .then((response) => response.json())
    .then((data) => callback(data))
    .catch((error) => console.error('POST ' + url + error))
}

// since delete was pre-registered word, I used remove
export const remove = (url, body = {}, callback) => {
  fetch(url, {
    method: 'DELETE',
    body: JSON.stringify(body),
    headers: new Headers({ 'Content-type': 'application/json' }),
    credentials: 'include',
  })
    .then((response) => response.json())
    .then((data) => callback(data))
    .catch((error) => console.error('GET ' + url + error))
}

import axios from 'axios'
export const postFormData = (url, params = {}, callback) => {
  axios
    .post(url, params)
    .then((response) => response)
    .then((data) => callback(data))
    .catch((error) => console.error('POST ' + url + error))
}
